module.exports = __webpack_public_path__ + "static/img/dgg.72cfc60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dgg.png
// module id = TEZ6
// module chunks = 1